// Homepage — benefity hned pod karuselem, bannery „Objevte naše produkty“ až za nimi
function placeHomeBanners() {
    const $banners = $(".next-to-carousel-banners");
    const $benefits = $(".benefitBanner.position--benefitHomepage");

    if ($banners.length == 0) {
        return;
    }

    if ($benefits.length) {
        if (!$benefits.next().is($banners)) {
            $banners.insertAfter($benefits);
        }
    } else if ($banners.closest(".banners-row").length) {
        $banners.prependTo($(".homepage-box.before-carousel").next(".content-wrapper").find("main.content"));
    }
}

$(document).ready(function () {
    if ($(".in-index").length) {
        // Až po main.js — recenze se vkládají hned za benefity
        setTimeout(placeHomeBanners, 0);
    }
});
